export { Vehicle as default } from "./vehicle";
